import React from 'react';

import { createDashboardPasswordEditorClassName } from './dashboardPasswordEditorStyles';

export const DashboardPasswordEditorControls: React.FC = ({ children }) => {
  return (
    <div className={createDashboardPasswordEditorClassName('controls')}>
      {children}
    </div>
  );
};
